"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.html = html;
exports.unsafeToHtml = unsafeToHtml;
exports.textForHtmlEmail = textForHtmlEmail;
/** Tagged template literal for creating HtmlString values from inline HTML. */
function html(strings, ...values) {
    return String.raw(strings, ...values);
}
/** Escape hatch for casting a dynamically-built HTML string. Use sparingly. */
function unsafeToHtml(value) {
    return value;
}
/**
 * Converts plain-text newlines to HTML <br> for display in the SendGrid template.
 * Only use on plain-text content (e.g. NNR templates). Do NOT apply to HTML email
 * bodies — inserting <br> inside HTML tags breaks their structure.
 */
function textForHtmlEmail(body) {
    return body.replace(/\n/g, "<br>");
}
//# sourceMappingURL=htmlTypeSafety.js.map